import React from 'react';

/**
 * Invisible-but-indexable SEO content block.
 * Uses inline styles equivalent to the "sr-only" pattern: content is reachable
 * by crawlers and screen readers but visually hidden from sighted users.
 * This pushes the site for long-tail local queries around Annecy / Rhône-Alpes.
 */
const srOnly = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0,0,0,0)',
  whiteSpace: 'nowrap',
  border: 0
};

const SeoContent = () => {
  return (
    <section aria-label="Informations supplémentaires - Gestion de patrimoine Annecy et Rhône-Alpes" style={srOnly}>
      <h2>Conseiller en gestion de patrimoine à Annecy, Annecy-le-Vieux et toute la Haute-Savoie</h2>
      <p>
        Arthur Vacogne, conseiller en gestion de patrimoine indépendant et Conseiller
        en Investissements Financiers (CIF) inscrit à l'ORIAS et membre de la CNCIF,
        accompagne particuliers, dirigeants d'entreprise, professions libérales,
        chefs d'entreprise, indépendants, salariés du privé, fonctionnaires,
        retraités, frontaliers Suisse et comités sociaux et économiques (CSE).
        ActiV Patrimoine propose une approche globale, transparente et accessible
        de la gestion de patrimoine, du conseil financier et du placement financier
        sur-mesure.
      </p>

      <h2>Zones d'intervention : Haute-Savoie 74, Savoie 73, Isère 38, Rhône 69, Ain 01, Auvergne-Rhône-Alpes et France entière</h2>
      <p>
        Cabinet de gestion de patrimoine basé à Annecy-le-Vieux (74940),
        intervention sur l'ensemble du bassin annécien et du Genevois français :
        Annecy, Annecy-le-Vieux, Cran-Gevrier, Seynod, Meythet, Pringy, Argonay,
        Épagny Metz-Tessy, Poisy, Veyrier-du-Lac, Menthon-Saint-Bernard,
        Talloires-Montmin, Duingt, Saint-Jorioz, Sevrier, Faverges-Seythenex,
        Doussard, Lathuile, Alby-sur-Chéran, Rumilly, Frangy, Cruseilles.
      </p>
      <p>
        Bassin lémanique et frontaliers Suisse : Annemasse, Gaillard, Vétraz-Monthoux,
        Ambilly, Ville-la-Grand, Saint-Julien-en-Genevois, Bonneville, La Roche-sur-Foron,
        Reignier-Ésery, Bons-en-Chablais, Thonon-les-Bains, Évian-les-Bains,
        Publier, Lugrin, Sciez, Douvaine, Cluses, Sallanches, Passy, Chamonix-Mont-Blanc,
        Saint-Gervais-les-Bains, Megève, Combloux, Praz-sur-Arly, Les Houches,
        Servoz, Magland.
      </p>
      <p>
        Savoie (73) : Chambéry, Aix-les-Bains, Albertville, Saint-Jean-de-Maurienne,
        Moûtiers, Bourg-Saint-Maurice, Ugine, La Motte-Servolex, Cognin,
        Challes-les-Eaux, Montmélian, Saint-Pierre-d'Albigny.
      </p>
      <p>
        Isère (38) : Grenoble, Échirolles, Voiron, Bourgoin-Jallieu, Vienne,
        L'Isle-d'Abeau, Crolles, Meylan, Saint-Martin-d'Hères, Fontaine,
        Le Pont-de-Claix, Pontcharra.
      </p>
      <p>
        Rhône (69) : Lyon, Villeurbanne, Caluire-et-Cuire, Bron, Vénissieux,
        Sainte-Foy-lès-Lyon, Tassin-la-Demi-Lune, Écully, Oullins, Saint-Priest,
        Vaulx-en-Velin, Givors, Brignais, Mornant.
      </p>
      <p>
        Ain (01) : Bellegarde-sur-Valserine, Oyonnax, Bourg-en-Bresse, Gex,
        Ferney-Voltaire, Saint-Genis-Pouilly, Divonne-les-Bains, Belley, Ambérieu-en-Bugey.
      </p>

      <h2>Services de gestion de patrimoine et conseil en investissement à Annecy</h2>
      <ul>
        <li>Bilan patrimonial personnalisé offert, sans engagement et sans honoraires.</li>
        <li>Optimisation fiscale, défiscalisation, réduction d'impôt sur le revenu et de l'IFI.</li>
        <li>Investissement immobilier locatif neuf et ancien : Pinel, Pinel+, Denormandie, LMNP, LMP, Malraux, Monuments Historiques, déficit foncier, nue-propriété, démembrement.</li>
        <li>SCPI de rendement, SCPI fiscales, SCPI européennes, SCPI de plus-value, pierre papier.</li>
        <li>Assurance vie multisupport haut de gamme, assurance vie luxembourgeoise, contrat de capitalisation, contrat d'assurance vie pour les expatriés et non-résidents.</li>
        <li>Placement financier sur-mesure : actions, obligations, fonds euros, unités de compte, ETF, OPCVM, gestion pilotée, gestion sous mandat.</li>
        <li>Plan Épargne Retraite (PER) individuel et entreprise, PERCO, PERIN, PERCOL.</li>
        <li>Préparation retraite et revenus complémentaires à la retraite, calcul retraite, audit retraite.</li>
        <li>Transmission patrimoine, donation, donation-partage, succession, démembrement de propriété, SCI familiale, pacte Dutreil.</li>
        <li>Solutions patrimoniales dirigeants et sociétés : optimisation trésorerie d'entreprise, rémunération dirigeant, arbitrage dividendes / rémunération / épargne.</li>
        <li>Épargne salariale, intéressement, participation, PEE, PERCOL pour entreprises.</li>
        <li>Prévoyance dirigeant, prévoyance homme clé, protection sociale du dirigeant TNS et assimilé salarié.</li>
        <li>Renégociation assurance de prêt immobilier (Loi Lemoine), délégation assurance emprunteur, économies sur assurance crédit immobilier.</li>
        <li>Conseil patrimonial pour frontaliers Suisse : optimisation fiscalité franco-suisse, 2e pilier LPP, 3e pilier, rachat trimestres, retour en France.</li>
        <li>Capital investissement, private equity, Plan Épargne en Actions PEA, PEA-PME, FCPI, FIP, financement d'amorçage.</li>
        <li>Formation patrimoniale gratuite pour Comités Sociaux et Économiques (CSE) et Comités d'Entreprise (CE).</li>
      </ul>

      <h2>Pourquoi choisir un conseiller en gestion de patrimoine indépendant à Annecy ?</h2>
      <p>
        Conseiller en gestion de patrimoine indépendant (CGPI), gestionnaire de
        patrimoine indépendant, family officer indépendant, conseiller financier
        indépendant, gestion privée indépendante : Arthur Vacogne propose une
        analyse patrimoniale impartiale, multi-partenaires, sans pression commerciale,
        au service exclusif de vos objectifs de vie et de votre situation patrimoniale.
        La rémunération s'effectue uniquement auprès des partenaires fournisseurs
        de solutions, comme un courtier immobilier, sans honoraires client.
      </p>

      <h2>Mots-clés et expertise</h2>
      <p>
        Gestion de patrimoine Annecy, gestion de patrimoine Annecy-le-Vieux,
        gestionnaire de patrimoine Annecy, conseiller en gestion de patrimoine Annecy,
        conseiller en investissement Annecy, CGP Annecy, CGPI Annecy, conseiller
        financier Annecy, audit patrimonial Annecy, bilan patrimonial gratuit Annecy,
        conseil en placement Annecy, défiscalisation Annecy, immobilier locatif Annecy,
        SCPI Annecy, assurance vie Annecy, PER Annecy, retraite Annecy,
        succession Annecy, donation Annecy, expert patrimoine Haute-Savoie,
        wealth management Annecy, family office Haute-Savoie, gestion privée 74,
        cabinet de gestion de patrimoine Annecy, expert-conseil patrimoine Haute-Savoie,
        conseiller financier indépendant Haute-Savoie, conseiller fiscal Annecy,
        cabinet patrimonial Rhône-Alpes, gestion fortune Annecy, fortune privée
        Haute-Savoie, conseiller patrimonial frontalier Suisse, conseiller frontalier
        Genève, conseiller patrimonial expatriés.
      </p>

      <h3>Coordonnées</h3>
      <address>
        <p>ActiV Patrimoine - Arthur Vacogne</p>
        <p>Conseiller en gestion de patrimoine - Annecy-le-Vieux, Haute-Savoie (74940)</p>
        <p>Téléphone : <a href="tel:+33689300292">06 89 30 02 92</a></p>
        <p>Email : <a href="mailto:arthur.vacogne@gmail.com">arthur.vacogne@gmail.com</a></p>
        <p>Site officiel : <a href="https://arthurvacogne.fr">https://arthurvacogne.fr</a></p>
      </address>
    </section>
  );
};

export default SeoContent;
